import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationLearningDevelopment(props) {
  return (
    <svg
      viewBox="0 0 142 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.945 50.767l50.766 50.766 50.765-50.766 19.944 19.944-51.672 51.673c-10.514 10.514-27.56 10.514-38.075 0L.001 70.711l19.944-19.944z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.509 55.733l-27.901-27.63L23.57 47.14l28.354 28.084c10.264 10.264 26.904 10.264 37.168 0l28.48-28.362-19.038-19.037L70.51 55.733z"
        fill="currentColor"
      />
      <circle
        cx={70.71}
        cy={24.88}
        transform="rotate(-45 70.71 24.88)"
        fill="currentColor"
        r={17.592}
      />
    </svg>
  );
}

export default IllustrationLearningDevelopment;
